import { useState, useEffect } from 'react';
import useFetchFinancialData  from './useFetchFinacialData'; 
import { processFinancialData } from '../utilities/dataProccesingUtils';
import { isEqual } from 'lodash';

const useBudgetData = (selectedCompany, startDate, endDate, sourceType) => {
  const [processedBudgetData, setProcessedBudgetData] = useState([]);
  sourceType = "budget"
  const { data, isLoading, error } = useFetchFinancialData(selectedCompany, startDate, endDate, "budget");

  useEffect(() => {
    if (data && data.budgetData) {
      const newProcessedBudgetData = processFinancialData(data.budgetData, sourceType);
      if (!isEqual(processedBudgetData, newProcessedBudgetData)) {
        setProcessedBudgetData(newProcessedBudgetData);
      }
    }
  }, [data, processedBudgetData, sourceType]);
  

  return {
    processedBudgetData,
    isLoading,
    error,
  };
};

export default useBudgetData;